let counter = 0;
let selector = ".bss-b2b-custom-fields"
const interval = setInterval(() => {
    let element = document.querySelector(selector);
    if (element) {
        console.log("Phần tử đã xuất hiện");
        clearInterval(interval);
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100); 